import { render, staticRenderFns } from "./SetRegionAutoSync.vue?vue&type=template&id=cfe7be06&"
import script from "./SetRegionAutoSync.vue?vue&type=script&lang=js&"
export * from "./SetRegionAutoSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports